<template>
    <div class="sidebar"
         :style="{background: bgcolor, color: color}">
        <div class="content">
            <CompanyList/>
            <h3>Laitteet</h3>
            <input type="checkbox" v-model="selectAll" v-on:change="selectOrDeselectAllDevices" />Valitse kaikki
            <input type="text" placeholder="Suodata" v-model="filterText" />
            <div class="devices-list-status-indicator">{{statusIndicator}}</div>
            <div v-for="device in deviceFilter(devices)" class="devicesList">
                <input type="checkbox" name="selectedDevices[]"
                    v-model="selectedDevices"
                    v-on:change="emitDevices"
                    :value="device.deviceId"
                    :id="device.deviceId"
                    :data-device-name="device.displayName ? device.displayName : device.deviceId"
                >
                <label
                    :for="device.deviceId"
                >
                    {{ device.displayName ? device.displayName : device.deviceId }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>

    import EventBus from '../../service/EventBus';
    import { FoxEnvs } from '../../service/foxeriot_environments';
    import { default as CompanyList } from './CompanyList';
    import axios from 'axios';

    export default {
        name: 'DeviceList',
        components: {CompanyList},
        data() {
            return {
                statusIndicator: '',
                devices: null,
                filterText: '',
                selectedDevices: [],
                token: null,
                selectAll: false,
            }
        },
        methods: {
            getDevices: function (token) {
                this.token = token;

                this.statusIndicator = 'Ladataan...'
                this.devices = []
                this.selectedDevices = []
                this.selectAll = false;

                axios.get(FoxEnvs.prod.baseUrl + '/api/v1/get-devices', {
                    headers: {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then( (response) => {
                    if ((response.data.data).length === 0) {
                        this.statusIndicator = 'Laitteita ei löytynyt'
                        return false;
                    } else {
                        this.statusIndicator = ''
                        this.setDevices(response.data.data)
                    }
                }).catch( (error) => {
                    this.statusIndicator = 'Laitteiden lataus ei onnistunut'
                    return error;
                });
            },
            setDevices: function(data) {
                this.devices = data
            },
            emitDevices: function (e) {
                if (e.target.checked) {
                    let device = {
                        id: e.target.id,
                        name: e.target.dataset.deviceName
                    };
                    this.$store.commit('addDevice', device);
                } else {
                    this.$store.commit('removeDevice', e.target.id);
                    this.$store.commit('removeDeviceStatus', e.target.id);
                }
            },
            deviceFilter: function(devices) {
                if(devices !== null && this.filterText !== ''){
                    let filterText = this.filterText.toLowerCase();
                    return devices.filter(function (device) {
                        return (device.displayName ? device.displayName : device.deviceId).toLowerCase().includes(filterText);
                    })
                }
                return devices;
            },
            selectOrDeselectAllDevices: function() {
                this.selectedDevices = [];
                this.$store.commit('clearDevices');
                this.$store.commit('clearDeviceStatuses');

                if (this.selectAll) {
                    this.deviceFilter(this.devices).forEach((device) => {
                        let _device = {
                            id: device.deviceId,
                            name: device.displayName
                        };
                        this.$store.commit('addDevice', _device);
                        this.selectedDevices.push(device.deviceId);
                    });
                }
            }
        },
        computed: {
            bgcolor: function() {
                return this.$store.getters.sidebg;
            },
            color: function() {
                return this.$store.getters.sidetext;
            }
        },
        mounted() {
            EventBus.$on('accountToken', (e) => {
                this.getDevices(e);
            });
        }
    }
</script>

<style scoped>
    h3 {
        text-align: center;
    }
    .devicesList label {
        font-size: 0.8em;
    }
    div {
        text-align: left;
    }
    .devices-list-status-indicator {
        margin: auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/app/Main/components/DeviceList.vue